// extracted by mini-css-extract-plugin
export default {"sh":"Simple_sh__t2d5W","sv":"Simple_sv__aqN3H","doc":"Simple_doc__GZBih","paragraph":"Simple_paragraph__v68Ff"};